export default {
  PUBLIC_SEARCH: {
    SELECT_ALL: 'Todos',
    TITLE: 'Encuentra tu próximo trabajo',
    SUBTITLE: 'Miles de ofertas de empleo esperan por ti',
    META: { TITLE: 'Buscar ofertas de empleo' },
    TABS: {
      OFFERS: 'Ofertas de empleo',
      OFFERS_SHORT: 'Ofertas',
      COMPANIES: 'Empresas',
    },
    OFFERS: {
      SEARCH_PLACEHOLDER: 'Título del puesto, empresa o ciudad...',
      SEARCH_BTN: 'Buscar',
      RESULTS_COUNT: 'ofertas encontradas',
      NO_RESULTS: 'No se encontraron ofertas',
      NO_RESULTS_HINT: 'Prueba con otros filtros o términos de búsqueda.',
      NO_RESULTS_COMPANY_TITLE: 'Empresa sin ofertas activas',
      NO_RESULTS_COMPANY_HINT: 'Por ahora, esta empresa no tiene ofertas activas.\nBusca otra empresa o explora otras ofertas que puedan interesarte.',
      FILTERS: {
        COMPANY: 'Empresas',
        TYPE: 'Modalidad',
        CONTRACT_TYPE: 'Tipo de empleo',
        WORKING_DAY: 'Tipo de jornada',
        COUNTRY: 'País',
        CITY: 'Ciudad / Población',
        PUBLISHED_WITHIN: 'Por fecha de publicación',
        PUBLISHED_24H: 'Últimas 24 horas',
        PUBLISHED_3D: 'Últimos 3 días',
        PUBLISHED_7D: 'Últimos 7 días',
        PUBLISHED_15D: 'Últimos 15 días',
        PUBLISHED_1M: 'Último mes',
        CLEAR: 'Limpiar filtros',
      },
      SORT: {
        PLACEHOLDER: 'Ordenar por...',
        PLACEHOLDER_SHORT: 'Ordenar...',
        RECENT: 'Más recientes',
        RELEVANT: 'Más inscrit@s',
        RELEVANT_TOOLTIP: 'Ofertas con mayor número de candidat@s inscrit@s',
        SALARY: 'Mayor salario',
        ALPHABETICAL: 'Nombre A-Z',
      },
      DOWNLOAD_APP_TEXT: 'Estas son solo algunas de las ofertas disponibles.\n Descarga la app de wokap para verlas todas.',
      CARD: { PUBLISHED: 'Fecha de publicación', WATCH_VIDEO: 'Ver vídeo de la oferta', PREVIEW: 'Vista previa', APPLY: 'Inscribirse en la oferta' },
    },
    COMPANIES: {
      SEARCH_PLACEHOLDER: 'Nombre de la empresa...',
      SEARCH_BTN: 'Buscar',
      RESULTS_COUNT: 'empresas encontradas',
      NO_RESULTS: 'No se encontraron empresas',
      NO_RESULTS_HINT: 'Prueba con otros filtros o términos de búsqueda.',
      FILTERS: {
        COUNTRY: 'País',
        SECTOR: 'Sector',
        SIZE: 'Tamaño',
        HAS_ACTIVE_OFFERS_TITLE: 'Ofertas activas',
        HAS_ACTIVE_OFFERS: 'Con ofertas activas',
        CITY: 'Ciudad / Población',
        CLEAR: 'Limpiar filtros',
      },
      SORT: {
        PLACEHOLDER: 'Ordenar por...',
        PLACEHOLDER_SHORT: 'Ordenar...',
        RECENT: 'Ofertas recientes',
        MORE_OFFERS: 'Mayor # de ofertas',
        ALPHABETICAL: 'Nombre A-Z',
      },
      SIZES: {
        MICRO: '1-9 emplead@s',
        SMALL: '10-49 emplead@s',
        MEDIUM: '50-249 emplead@s',
        LARGE: '250+ emplead@s',
      },
      DOWNLOAD_APP_TEXT: 'Estas son solo algunas de las empresas que usan wokap.\nDescarga la app de wokap para conocerlas todas.',
      DOWNLOAD_APP_TEXT_MOBILE: 'Estas son algunas empresas que usan wokap.\nDescarga la app de wokap para conocerlas todas.',
      CARD: {
        ACTIVE_OFFERS: 'oferta(s) activa(s)',
        NO_OFFERS: 'Sin ofertas activas',
      },
    },
    GEO: {
      USE_LOCATION: 'Usar mi ubicación',
      ACTIVE: 'Ubicación activa',
      CLEAR: 'Quitar ubicación',
      DISTANCE: 'Distancia (de tu ubicación actual)',
      ANY_DISTANCE: 'Distancia',
      LOCATION_DENIED: 'Permiso de ubicación denegado',
      LOCATION: 'Ubicación',
    },
    FILTER_BTN: 'Filtrar',
    FILTER_BTN_COUNT_SINGULAR: '1 Filtro aplicado',
    FILTER_BTN_COUNT_PLURAL: '{{count}} Filtros aplicados',
    FILTER_OFFERS: 'Filtrar ofertas',
    FILTER_COMPANIES: 'Filtrar empresas',
    SHOW_RESULTS: 'Mostrar resultados',
    APPLY_FILTERS: 'Aplicar filtros',
    APPLY: 'Aplicar',
    CLEAR_FILTERS: 'Borrar filtros',
    CLEAR_ALL: 'Borrar todo',
    CLEAR_FILTER: 'Borrar',
    SEARCH_COUNTRY: 'Buscar país…',
    SEARCH_CITY: 'Buscar ciudad / población…',
    SEARCH_SECTOR: 'Buscar sector…',
    SEARCH_COMPANY: 'Buscar empresa…',
    LOADING: 'Buscando…',
    HEADER: { SEARCH_JOBS: '¿Eres empresa?', DOWNLOAD_APP: 'Bajar app' },
  },
} as const;
